import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer"; // Assuming you might want Footer, but kept imports clean based on your file
import styles from "./AdminLoginPage.module.css"; // Reusing login styles
import axios from "axios";

// AUTOMATIC DOMAIN SWITCHER (Localhost vs Live)
const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "/api"
    : "https://dukamo.dukamocoffee.com/api";

function HiderLoginPage() {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      // 1. Send the code to the backend
      const res = await axios.post(`${API_BASE_URL}/cms/verify-login`, {
        code,
      });

      if (res.data.success) {
        // 2. If Backend says OK, save the code as the KEY
        // We save the 'code' itself because that IS the key expected by the headers
        sessionStorage.setItem("hider_admin_key", code);

        // Also keep your legacy flag just in case other files use it
        sessionStorage.setItem("hider_access_token", "secure_active");

        navigate("/admin/orders");
      }
    } catch (err) {
      console.error("Login Check Error:", err);
      setError("Access Denied. Invalid Security Code.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.adminLoginPage}>
      <Navbar />
      <div className={styles.adminLoginContainer}>
        <form
          className={styles.adminLoginForm}
          onSubmit={handleLogin}
          style={{ border: "2px solid #00e5ff" }}
        >
          <h2 style={{ color: "#00e5ff" }}>Hider Tech Access</h2>
          <p
            style={{ color: "#999", textAlign: "center", marginBottom: "20px" }}
          >
            Sales & Logistics Dashboard
          </p>

          <div className={styles.formGroup}>
            <label>Security Code</label>
            <input
              type="password"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Enter Hider Key"
              required
            />
          </div>

          {error && <p className={styles.loginError}>{error}</p>}

          <button
            type="submit"
            className={styles.loginBtn}
            style={{ backgroundColor: "#00e5ff", color: "#000" }}
            disabled={loading}
          >
            {loading ? "Verifying..." : "Secure Login"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default HiderLoginPage;
